import { Route, Routes, Navigate, useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { Suspense, useState, useEffect, useCallback, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import Sidebar from "./Components/Sidebar/Sidebar";
import Topbar from "./Components/Topbar/Topbar";
import ProtectedRoute from "./routes/ProtectedRoute";
import Loader from "./Components/Common/Loader";
import routes from "./routes/routes";
import { fetchUserProfile } from "./Redux/Auth/action";
import { AccessProvider } from "./access/AccessContext";
import RequirePermission from "./Components/Common/RequirePermission";
import "./App.css";

const Providers = lazy(() => import("./Pages/Providers/Providers"));

// Pages that render their own cards on the page background.
const BARE_ROUTES = ["/dashboard", "/iam/users", "/iam/roles", "/patients"];

const getAuthParams = (searchParams) => ({
  accessToken: searchParams.get("vt") || Cookies.get("Token"),
  userId: searchParams.get("ui") || Cookies.get("UserId"),
  tenantId: searchParams.get("ti") || Cookies.get("TenantId"),
});
const updateDocumentTitle = (path) => {
  const titles = {
    "/": "Home - Central Admin",
    "/dashboard": "Dashboard - Central Admin",
    "/iam/users": "Admin Users - Central Admin",
    "/iam/roles": "Roles & Permissions - Central Admin",
    "/iam/provider-users": "Provider Users - Central Admin",
    "/partners": "Partners - Central Admin",
    "/patients": "Patients - Central Admin",
    "/apps/website": "Website - Central Admin",
    "/apps/patient": "Patient App - Central Admin",
    "/apps/practitioner": "Practitioner App - Central Admin",
    "/apps/studio": "Studio - Central Admin",
    "/apps/admin": "Admin Panel - Central Admin",
    "/apps/accounts": "Accounts - Central Admin",
    "/trust": "Trust - Central Admin",
    "/support": "Support - Central Admin",
    "/general": "General Settings - Central Admin",
    "/unauthorized": "Unauthorized Access - Central Admin",
    "*": "Page Not Found - Central Admin",
  };
  document.title = titles[path] || "Central Admin";
};
function App() {
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location =  useLocation()
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userReducer);
  const [searchParams] = useSearchParams();
  const { accessToken, userId, tenantId } = getAuthParams(searchParams);
  const navigate =  useNavigate()
 

  useEffect(() => {
    if (userId && accessToken && tenantId && !profile) {
      dispatch(fetchUserProfile({ userId, accessToken, tenantId,navigate }));
    }
    const timeOut =  setTimeout(()=>setLoading(false),1000)
   
    return () => clearTimeout(timeOut)
  }, [userId, accessToken, tenantId, profile, dispatch]);

     
  useEffect(()=>{
    updateDocumentTitle(location.pathname);
  },[location.pathname])
 
  if(loading && !profile){
    return <Loader/>;
  }

  const bare = BARE_ROUTES.includes(location.pathname) || location.pathname.startsWith("/subscriptions");

  return (
    <AccessProvider>
      <div className="flex h-[100vh] bg-canvas text-slate-900">
        <Toaster position="top-center" reverseOrder={false} />
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="flex h-[100vh] min-w-0 flex-1 flex-col overflow-hidden">
          <Topbar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
          <main className="customScrollbar flex-1 overflow-y-auto p-4 sm:p-6">
            <div className={bare ? "mx-auto w-full max-w-[1400px]" : "mx-auto min-h-full w-full max-w-[1400px] rounded-xl border border-slate-200 bg-white shadow-card"}>
              <Suspense fallback={<Loader />}>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  <Route
                    path="/providers"
                    element={
                      <ProtectedRoute>
                        <RequirePermission module="providers">
                          <Providers />
                        </RequirePermission>
                      </ProtectedRoute>
                    }
                  />
                  {routes.map((route, index) => (
                    <Route key={index} path={route.path} element={route.component} />
                  ))}
                </Routes>
              </Suspense>
            </div>
          </main>
        </div>
      </div>
    </AccessProvider>
  );
}
export default App;